/**
 * Big trades table
 */
import { Suspense } from 'react';
import {
  Await,
  Link,
  matchPath,
  useLoaderData,
  useNavigation,
  useSearchParams,
} from 'react-router-dom';
import Text from '../../atoms/Text';
import Image from '../../atoms/Image';
import ChainSelector from '../../components/ChainSelector';
import Modal from '../../components/Modal';
import Loader from '../../components/common/Loader';
import Header from '../MainPage/Header';
import backIcon from '../../assets/images/arrow_left.svg';
import BigTradesTable from './BigTradesTable';
import { bigTradesPageLoaderDataType } from '../loaders/bigTradesLoader';
import './styles.scss';

const BigTradesPage = () => {
  const [search, setSearch] = useSearchParams();
  const navigation = useNavigation();
  const { trades } = useLoaderData() as Record<string, unknown>;

  const chain = search.get('chain')!;

  const onSetChain = (c: string) => setSearch({ chain: c });

  const isNavigationOnCurrentRoute = matchPath(
    '/big-trades',
    navigation.location?.pathname ?? ''
  );

  const loading = navigation.state === 'loading' && isNavigationOnCurrentRoute;

  return (
    <Suspense
      fallback={
        <div className='centrify'>
          <Loader />
        </div>
      }
    >
      <Await resolve={trades} errorElement={<div>Error Loading</div>}>
        {(data: bigTradesPageLoaderDataType) => {
          return (
            <div className='bigTradesPage'>
              <Header chartPicker={false} />
              <div className='bigTradesPage__container'>
                <div className='newPairsPage__container__line'>
                  <Link to='/'>
                    <Image src={backIcon} className='back__btn' size='l' />
                  </Link>
                  <Text size={18} className='title text--grey-200'>
                    Big trades
                  </Text>
                </div>
                <ChainSelector selected={chain} onSet={onSetChain} />
                {loading ? (
                  <Loader className='bigTradesPage__container__loader' />
                ) : (
                  <BigTradesTable trades={data || []} />
                )}
              </div>
              <Modal />
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};

export default BigTradesPage;
